<template>
  <v-container fluid py-0 px-0 id="order-add-edit">
    <u-i-toolbar-admin :title="titlePage" :icon="icon" @click-back="onClickBack"/>
    <v-layout align-center py-3 fill-height>
      <v-flex xs11>
        <div v-html="formData"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';

export default {
  name: 'AdminPrint',
  props: {
    target: {
      required: false,
      type: String,
      default: '',
    },
  },
  components: {
    UIToolbarAdmin
  },
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  data: () => ({
    formData: '',
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.query.target) {
        this.getData();
      }
    },
    getData() {
      this.$store.commit('setLoading', true);
      this.axios.get(this.$route.query.target)
        .then(response => {
          this.formData = response.data;
          this.$nextTick(() => {
            print();
          });
        })
        .catch(error => {
          this.$store.dispatch('setError', this.$helpers.getProp(error, 'response.data.message', 'Something went wrong!'));
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    onClickBack() {
      this.$router.push(this.$route.query.back || '/');
    }
  },
  computed: {
    titlePage() {
      return 'Print page';
    },
    icon() {
      return 'file_download';
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-toolbar {
  @media print {
    display: none !important;
  }
}
</style>
